/**
 * Framer Motion animation variants for the Pastel Design System.
 */
import type { Variants } from "framer-motion";

export const fadeInUp: Variants = {
	hidden: { opacity: 0, y: 20 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
	exit: { opacity: 0, y: -10, transition: { duration: 0.3 } },
};

export const cardHover: Variants = {
	rest: { y: 0, scale: 1, boxShadow: "0 4px 6px -1px rgba(108,99,255,0.07)" },
	hover: {
		y: -4,
		scale: 1.02,
		boxShadow: "0 20px 25px -5px rgba(108,99,255,0.1)",
		transition: { duration: 0.2, ease: "easeOut" },
	},
};

export const buttonHover: Variants = {
	rest: { scale: 1 },
	hover: { scale: 1.03, transition: { duration: 0.15 } },
	tap: { scale: 0.95, transition: { duration: 0.1 } },
};

export const staggerContainer: Variants = {
	hidden: { opacity: 0 },
	visible: {
		opacity: 1,
		transition: { staggerChildren: 0.08, delayChildren: 0.1 },
	},
};

export const staggerItem: Variants = {
	hidden: { opacity: 0, y: 15 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export const scaleIn: Variants = {
	hidden: { opacity: 0, scale: 0.9 },
	visible: { opacity: 1, scale: 1, transition: { duration: 0.3, ease: "easeOut" } },
};

/** Slide-in-right with spring for mobile drawer (AC#2). */
export const slideInRight: Variants = {
	hidden: { x: "100%" },
	visible: { x: 0, transition: { type: "spring", damping: 25, stiffness: 300 } },
	exit: { x: "100%", transition: { duration: 0.25, ease: "easeIn" } },
};

export const fadeOverlay: Variants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1, transition: { duration: 0.2 } },
	exit: { opacity: 0, transition: { duration: 0.2 } },
};
